import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { VideoIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { GlassWhatsApp } from './ContactButtons';
import { contact } from '../data/site';
export function VideoCall() {
  const reduce = useReducedMotion();
  return <section className="relative w-full overflow-hidden bg-ink py-16 sm:py-24" data-id="element-202" data-mp="1ajed08sfb8r2">
      <img src="https://cdn.magicpatterns.com/patterns/generated-images/29abb180-dd0e-4a61-b752-1d4bcb96e069.jpg" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full scale-105 object-cover opacity-25 blur-md" data-id="element-203" data-mp="1y9qqs0acnzpk" />
      <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/85 to-ink" data-id="element-204" data-mp="1ojfcpkwyca4y" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_45%,rgba(212,160,23,0.16),transparent_62%)]" data-id="element-205" data-mp="1th7fj9z4xgnx" />

      <div className="relative mx-auto max-w-3xl px-5 text-center" data-id="element-206" data-mp="2h69to7uk8rdo">
        <Reveal data-id="element-207" data-mp="2lzutm5fprvfi">
          <span className="inline-flex items-center gap-2 rounded-full bg-wa/15 px-4 py-1.5 font-sans text-xs font-medium uppercase tracking-[0.18em] text-white ring-1 ring-wa/30" data-id="element-208" data-mp="2m0e2yxratbhx">
            <span className="relative flex h-2 w-2 shrink-0" aria-hidden="true" data-id="element-209" data-mp="3nvn61tyr6u3x">
              <span className="absolute inset-0 animate-ping rounded-full bg-wa opacity-75" data-id="element-210" data-mp="5he5tx7q5bne" />
              <span className="relative h-2 w-2 rounded-full bg-wa" data-id="element-211" data-mp="pdxbgdl9af7" />
            </span>
            Atención en vivo
          </span>
        </Reveal>

        <Reveal delay={0.08} data-id="element-212" data-mp="fgmvidvk443y">
          <motion.div className="relative mx-auto mt-10 flex h-28 w-28 items-center justify-center" animate={reduce ? undefined : {
          scale: [1, 1.04, 1]
        }} transition={{
          duration: 3.2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-213" data-mp="afpcjz2q361e">
            <span aria-hidden="true" className="absolute inset-0 rounded-full bg-gold/20 blur-2xl" data-id="element-214" data-mp="jeavhvc3wn2p" />
            <span className="relative flex h-24 w-24 items-center justify-center rounded-full bg-gold-light/10 ring-1 ring-gold-light/40" data-id="element-215" data-mp="2l8a6eflbh2ev">
              <VideoIcon className="h-11 w-11 text-gold-light" aria-hidden="true" data-id="element-216" data-mp="p66ogzzkr0kg" />
            </span>
          </motion.div>
        </Reveal>

        <Reveal delay={0.16} data-id="element-217" data-mp="z2rv1pr8sjqe">
          <h2 className="mt-10 font-serif text-4xl leading-tight text-gold-light sm:text-5xl lg:text-[3.5rem]" data-id="element-218" data-mp="z1gwc4cnm265">
            Recibe Tu Consulta en Videollamada
          </h2>
        </Reveal>

        <Reveal delay={0.24} data-id="element-219" data-mp="1826lwqbbmwbf">
          <p className="mx-auto mt-6 max-w-xl font-sans text-lg leading-relaxed text-white/70" data-id="element-220" data-mp="182y674zgx7me">
            Habla cara a cara con uno de nuestros maestros espirituales desde la comodidad de tu
            hogar. Agenda tu videollamada y recibe orientación personalizada.
          </p>
        </Reveal>

        <Reveal delay={0.32} data-id="element-221" data-mp="1mrb261yk2qgw">
          <div className="mt-10 flex justify-center" data-id="element-222" data-mp="1qtpk8juehm74">
            <GlassWhatsApp href={contact.videoCallHref} data-id="element-223" data-mp="1qvajunvknvbu">Agendar Videollamada</GlassWhatsApp>
          </div>
        </Reveal>
      </div>
    </section>;
}